import React, { useState, useEffect } from 'react';

import UserComponentUser from './UserComponentUser';
import DepartmentFilter from './DepartmentFilter';
import PublicationBarChart from './PublicationBarChart';
import Swal from 'sweetalert2';
import { useHistory } from "react-router-dom";

function Publication1() {
  const [userCounts, setUserCounts] = useState({
    UGC: 0,
    WOS: 0,
    SCI: 0,
    SCOPUS: 0,
    OTHERS: 0,
    Q1: 0,
    Q2: 0,
    Q3: 0,
    Q4: 0,
    Total: 0,
  });
  const history = useHistory();
  const accessLevel = sessionStorage.getItem('access_level');
  const handleViewYours = () => {
    // Navigate to the "View Yours" page
    history.push('/pub');
  };const handleViewYourss = () => {
    // Navigate to the "View Yours" page
    history.push('/my-beforepublications');
  };
  const handleViewDean = () => {

    history.push('/beforepubfordean');
  };
  const handleViewDepartment = () => {

    history.push('/publications');
  };
  const handleViewDepartmentt = () => {

    history.push('/beforepublications');
  };
  const handleAddPub = () => {

    history.push('/addpublications');
  };
  const [updatedFilters, setUpdatedFilters] = useState({});
  const [publications, setPublications] = useState([]); // Ensure this is always an array
  const [totalPages, setTotalPages] = useState(0);
  const [filterData, setFilterData] = useState({
    department: '',
    publicationType: '',
    indexing: '',
    fromyear: '',
    toyear: '',
  });
  const handleSearch = async (filters) => {
    if (filters) {
      // Remove empty fields from the filters
      const filtered = Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => value !== "")
      );
  
      setFilterData(filtered); // Update state with non-empty filters
  
      try {
        console.log('Fetching publications with filters:', filtered); // Debugging log
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/publications/filter`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(filtered), // Send only the non-empty filters
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const data = await response.json();
        console.log('Fetched data:', data); // Debugging log to verify data

        const publications = data._embedded && Array.isArray(data._embedded.publications)
          ? data._embedded.publications
          : [];
  
        console.log('Publications:', publications); // Log extracted publications
        
        const totalPages = data.page?.totalPages || 0;
        setTotalPages(totalPages); 
        //alert(totalPages);


        if (publications.length === 0) {
          console.warn('No publications found with the given filters.');
        }
  
        setPublications(publications); // Set state with the publications
  
      } catch (error) {
        console.error('Error fetching publications:', error);
      }
    }
  };
  
  // Fetch publications based on filterData
 

  // Fetch user counts from API
  useEffect(() => {
    const fetchUserCounts = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/publications/countByIndexing`);
        const data = await response.json();
        setUserCounts(data);
      } catch (error) {
        console.error('Error fetching user counts:', error);
      }
    };

    fetchUserCounts();
  }, []);

  // Fetch department-wise publication data
  const [publicationData, setPublicationData] = useState({});
  
  useEffect(() => {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/api/publications/department-publications`)
          .then((response) => {
              if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
          })
          .then((data) => setPublicationData(data))
          .catch((error) => console.error("Error fetching data:", error));
  }, []);



    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    // Function to fetch data from the backend
    const fetchPublicationData = async () => {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/publications/department-publications?startDate=${startDate}&endDate=${endDate}`;
        const response = await fetch(url);
        const data = await response.json();
        setPublicationData(data);
    };

    // Handle Search button click
    const handleSearchh = () => {
        fetchPublicationData();
    };

    // Optional: Automatically fetch data when component loads
    useEffect(() => {
        fetchPublicationData();
    }, []);


  return (
    <div className="container-fluid">
      <div className="row">
        {/* Quadrant 1 */}
        <div className="col-md-4">
          <div className="quadrant">
            <UserComponentUser userCounts={userCounts} />
          </div>
          <div className="quadrant h-8">
            <DepartmentFilter
              selectedDepartment={filterData.department}
              handleDepartmentChange={(e) => setFilterData({...filterData, department: e.target.value})}
            />
          </div>

          {/* FilterContainer below DepartmentFilter */}
          <div className="quadrant mt-8">
            <FilterContainer
              publicationTypes={['BOOK', 'INTERNATIONAL JOURNAL', 'NATIONAL JOURNAL']}
              indexingOptions={['SCI', 'SCOPUS', 'WEB OF SCIENCE','UGC']}
              onSearch={handleSearch}
              publications={publications} setPublications={setPublications}  // Pass handleSearch to update filters
            />
          </div>
        </div>

        {/* Quadrant 2 */}
        <div className="col-md-8">
        <div className="quadrant">
       
        {/* Heading */}
        <h1 >Publication Details</h1>
        <div className="d-flex justify-content-end align-items-center ml ms-3">
        <div className="d-flex align-items-center ms-3">
    {/* Conditional "View Department" Button */}
    {['1', '2', '3', '4', '5'].includes(accessLevel) && (
        <h6
        className="p-2 text-center border rounded text-light me-2"
        style={{
          cursor: 'pointer',
          width: '170px',
          height:"35px",
          textAlign: 'center',
          backgroundColor: 'var(--bs-primary)', // Bootstrap primary color
          transition: 'background-color 0.3s, color 0.3s', // Smooth transition
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#004085'; // Gray color on hover
          e.target.style.color = 'white'; // Ensure text remains readable
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'var(--bs-primary)'; // Original background
          e.target.style.color = 'white'; // Original text color
        }}
        onClick={handleViewDepartment}
      >
        View Department
      </h6>
    )}
     {['1', '2', '3', '4', '5'].includes(accessLevel) && (
        <h6
        className="p-2 text-center border rounded text-light me-2"
        style={{
          cursor: 'pointer',
          width: '170px',
          height:"35px",
          textAlign: 'center',
          backgroundColor: 'var(--bs-primary)', // Bootstrap primary color
          transition: 'background-color 0.3s, color 0.3s', // Smooth transition
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#004085'; // Gray color on hover
          e.target.style.color = 'white'; // Ensure text remains readable
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'var(--bs-primary)'; // Original background
          e.target.style.color = 'white'; // Original text color
        }}
        onClick={handleViewDepartmentt}
      >
      Publication(Approval)
      </h6>
    )}
    {/* Other Buttons */}
    <h6
        className="p-2 text-center border rounded text-light"
        style={{
          cursor: 'pointer',
          width: '150px',
          height:"35px",
          textAlign: 'center',
          backgroundColor: 'var(--bs-primary)', // Bootstrap primary color
          transition: 'background-color 0.3s, color 0.3s', // Smooth transition
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#004085'; // Gray color on hover
          e.target.style.color = 'white'; // Ensure text remains readable
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'var(--bs-primary)'; // Original background
          e.target.style.color = 'white'; // Original text color
        }}
        onClick={handleViewYourss}
      >
         Publication(Faculty)
      </h6>
      {['1', '2', '3', '4'].includes(accessLevel) && (
        <h6
        className="p-2 text-center border rounded text-light me-2"
        style={{
          cursor: 'pointer',
          width: '170px',
          height:"35px",
          textAlign: 'center',
          backgroundColor: 'var(--bs-primary)', // Bootstrap primary color
          transition: 'background-color 0.3s, color 0.3s', // Smooth transition
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#004085'; // Gray color on hover
          e.target.style.color = 'white'; // Ensure text remains readable
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'var(--bs-primary)'; // Original background
          e.target.style.color = 'white'; // Original text color
        }}
        onClick={ handleViewDean}
      >
      Dean(Approval)
      </h6>
    )}
    <h6
        className="p-2 text-center border rounded text-light"
        style={{
          cursor: 'pointer',
          width: '150px',
          height:"35px",
          textAlign: 'center',
          backgroundColor: 'var(--bs-primary)', // Bootstrap primary color
          transition: 'background-color 0.3s, color 0.3s', // Smooth transition
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#004085'; // Gray color on hover
          e.target.style.color = 'white'; // Ensure text remains readable
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'var(--bs-primary)'; // Original background
          e.target.style.color = 'white'; // Original text color
        }}
        onClick={handleViewYours}
      >
        View Yours
      </h6>
      <h6
        className="p-2 text-center border rounded text-light ms-2"
        style={{
          cursor: 'pointer',
          width: '170px',
          height:"35px",
          textAlign: 'center',
          backgroundColor: 'var(--bs-primary)', // Bootstrap primary color
          transition: 'background-color 0.3s, color 0.3s', // Smooth transition
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#004085'; // Gray color on hover
          e.target.style.color = 'white'; // Ensure text remains readable
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'var(--bs-primary)'; // Original background
          e.target.style.color = 'white'; // Original text color
        }}
        onClick={handleAddPub}
      >
        Add Publication
      </h6>
</div>


    </div>
  <div className="row">
    <div className="col-md-5 mb-3">
      <label htmlFor="startDate" className="form-label">Start Date</label>
      <input
        type="date"
        id="startDate"
        className="form-control"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
      />
    </div>
    <div className="col-md-5 mb-3">
      <label htmlFor="endDate" className="form-label">End Date</label>
      <input
        type="date"
        id="endDate"
        className="form-control"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
      />
    </div>
    <div className="col-md-2 d-flex align-items-end mb-3">
      <button
        onClick={handleSearchh}
        className="btn btn-primary w-100"
      >
        Search
      </button>
    </div></div>
            <PublicationBarChart publicationData={publicationData} />
          </div>
          <div className="col-md-12">
          <div className="quadrant" style={{ paddingBottom: '20px' , marginTop: '50px'}}>
            <h2>Publications</h2>
            <Publications publications={publications} setPublications={setPublications} totalPages={totalPages} setTotalPages={setTotalPages}/> {/* Ensure publications is always an array */}
          </div>
        </div>
        </div>
        
      </div>

      <div className="row mt-4 row min-vh-300">
        {/* Quadrant 3 */}
        <div className="col-md-4 ">

          
        </div>

        {/* Quadrant 4 - Publications */}
       
      </div>
    </div>
  );
}


const FilterContainer = ({ publicationTypes, indexingOptions, onSearch ,publications, setPublications }) => {
  const [departments, setDepartments] = useState([]);
  const [error, setError] = useState(null);
  const [filterData, setFilterData] = useState({
    department: '',
    publicationType: '',
    indexing: '',
    fromyear: '',
    toyear:'',
  });

  // Fetch departments from backend
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/departments`);
        if (!response.ok) {
          throw new Error('Failed to fetch departments');
        }
        const data = await response.json();
        setDepartments(data);
      } catch (error) {
        console.error('Error fetching departments:', error);
        setError(error.message);
      }
    };

    fetchDepartments();
  }, []);

  const handleSearch = (event) => {
    event.preventDefault();
    console.log('Filter Data:', filterData);
    onSearch(filterData); // Pass filter data back to Publications component
  };

  const handleChange = (e) => {
    setFilterData({
      ...filterData,
      [e.target.name]: e.target.value,
    });
  }; const handleReset = () => {
    setFilterData({
        department: '',
        publicationType: '',
        indexing: '',
        fromyear: '',
        toyear: ''
    });

    // Fetch all publications again
    const getPublications = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/publications/publications?page=0&size=100`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            const allPublications = data._embedded?.publications || [];
            setPublications(allPublications);
        } catch (error) {
            console.error('Error fetching publications:', error);
            setError('Failed to fetch publications.');
        }
    };
    getPublications();
};

  if (error) {
    return <div className="alert alert-danger">Error: {error}</div>;
  }

  return (
    <div className="container mt-5">
      <h4>Filter</h4>
      <form onSubmit={handleSearch}>
        <div className="row mb-3">
          {/* Department Dropdown */}
          <div className="col-12 mb-3">
            <label htmlFor="department" className="form-label">
              Department:
            </label>
            <select
              name="department"
              id="department"
              className="form-select"
              value={filterData.department}
              onChange={handleChange}
            >
              <option value="">Select a Department</option>
              {departments.map((dept) => (
                <option key={dept.deptId} value={dept.deptId}>
                  {dept.deptName}
                </option>
              ))}
            </select>
          </div>

          {/* Publication Type Dropdown */}
          <div className="col-12 mb-3">
            <label htmlFor="publicationType" className="form-label">
              Publication Type:
            </label>
            <select
              name="publicationType"
              id="publicationType"
              className="form-select"
              value={filterData.publicationType}
              onChange={handleChange}
            >
              <option value="">All Types</option>
              {publicationTypes.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>

          {/* Indexing Dropdown */}
          <div className="col-12 mb-3">
            <label htmlFor="indexing" className="form-label">
              Indexing:
            </label>
            <select
              name="indexing"
              id="indexing"
              className="form-select"
              value={filterData.indexing}
              onChange={handleChange}
            >
              <option value="">All Indexing</option>
              {indexingOptions.map((indexing, index) => (
                <option key={index} value={indexing}>
                  {indexing}
                </option>
              ))}
            </select>
          </div>

          {/* Year Input */}
          <div className="col-12 mb-3">
            <label htmlFor="year" className="form-label">
             From Year:
            </label>
            <input
              type="date"
              name="fromyear"
              id="fromyear"
              placeholder="Enter year"
              className="form-control"
              value={filterData.fromyear}
              onChange={handleChange}
            />
          </div>
          <div className="col-12 mb-3">
            <label htmlFor="year" className="form-label">
             To Year:
            </label>
            <input
              type="date"
              name="toyear"
              id="toyear"
              placeholder="Enter year"
              className="form-control"
              value={filterData.toyear}
              onChange={handleChange}
            />
          </div>
          <div className="row">
    {/* Search Button */}
    <div className="col-6">
        <button type="submit" className="btn btn-primary w-100">
            Search
        </button>
    </div>

    {/* Reset Button */}
    <div className="col-6">
        <button type="button" className="btn btn-secondary w-100" onClick={handleReset}>
            Reset
        </button>
    </div>
</div>

        </div>
      </form>
    </div>
  );
};

const Publications = ({ publications, setPublications, totalPages, setTotalPages}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPublications, setSelectedPublications] = useState(new Set());
  const [filters, setFilters] = useState({});
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  //const [totalPages, setTotalPages] = useState(0);
  const pageSize = 20;
  const [departments, setDepartments] = useState([]);
const [findTarget, setFindTarget] = React.useState(false);
const [selectedDepartment, setSelectedDepartment] = React.useState('');
const [fromYear, setFromYear] = React.useState('');
const [toYear, setToYear] = React.useState('');
const[count,setCount]=useState('');
const[tcount,settCount]=useState('');
const [target, setTarget] = useState(null); // Store target data


useEffect(() => {
  fetch(`${process.env.REACT_APP_API_BASE_URL}/api/departments`)
    .then((response) => response.json())
    .then((data) => setDepartments(data))
    .catch((error) => console.error("Error fetching departments:", error));
}, []);
const fetchPublicationss = async () => {
  let url = "";
  
  // Using full date from the input fields directly
  const startDate = fromYear ? `${fromYear}-06-01` : '';
  const endDate = fromYear ? `${parseInt(fromYear) + 1}-07-01` : '';
  
  try {
    if (findTarget) {
      // Fetch publications with full date range and department if applicable
      url = `${process.env.REACT_APP_API_BASE_URL}/api/publications/department?deptId=${selectedDepartment}&startDate=${startDate}&endDate=${endDate}`;
      const response = await fetch(url);
      console.log(url);
      if (!response.ok) {
        throw new Error("Failed to fetch publications");
      }
      const data = await response.json();
      console.log(data);
      setPublications(data.publications);
      setCount(data.count)
    
      fetchTarget(data.count);
    } else {
      // Fetch publications without filtering by department
      url = `${process.env.REACT_APP_API_BASE_URL}/api/publications/publications?page=0&size=100`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error("Failed to fetch publications");
      }
      const data = await response.json();
      console.log(data);
      settCount(data.setPubTarget)
     
      // Check if _embedded exists before accessing publications
      if (data._embedded && data._embedded.publications) {
        setPublications(data._embedded.publications);
      } else {
        throw new Error("Publications not found in response");
      }
    }
  } catch (error) {
    console.error("Error fetching publications:", error);
  }
};
const fetchTarget = async (publicationCount) => {
  try {
    const startDate = fromYear ? `${fromYear}-07-01` : '';
    const endDate = fromYear ? `${parseInt(fromYear) + 1}-06-30` : '';
    let targetUrl = `${process.env.REACT_APP_API_BASE_URL}/api/targets/p/${selectedDepartment}/${startDate}/${endDate}`;
    const response = await fetch(targetUrl);

    if (!response.ok) throw new Error("Failed to fetch target");

    const data = await response.json();
    setTarget(data);
    settCount(data.setPubTarget); // Store target in state

    await updateAttainedPubTarget(data.targetId, publicationCount);

    setTimeout(() => {
      const updatedTargetCount = data.setPubTarget;
      const updatedAttainedCount = publicationCount;
      const remainingTarget = updatedTargetCount - updatedAttainedCount;
    
      // Calculate actual progress percentage (can be > 100%)
      let progressPercentage = ((updatedAttainedCount / updatedTargetCount) * 100).toFixed(2);
      // Cap bar width at 100%
      const barWidth = progressPercentage > 100 ? 100 : progressPercentage;
    
      const today = new Date();
      const endDateObj = new Date(endDate);
      const displayEndDate = today < endDateObj ? today.toLocaleDateString() : endDateObj.toLocaleDateString();
    
      Swal.fire({
        title: `<h2 style="color: #2C3E50; font-weight: bold; font-size: 22px; text-align: center; margin-bottom: 12px;">Target Details</h2>`,
        html: `
          <div style="border: 1px solid #ccc; border-radius: 10px; padding: 20px; background-color: #F8F9FA; text-align: left;">
            <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
              <div style="font-size: 16px; color: #2C3E50;"><i class="fas fa-calendar-alt" style="color: #E67E22; margin-right: 6px;"></i><strong>Period:</strong></div>
              <div style="font-size: 16px; color: #007bff;">
                ${startDate.substring(0, 4)} To ${endDate.substring(0, 4)}
              </div>
            </div>
    
            <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
              <div style="font-size: 16px; color: #2C3E50;"><i class="fas fa-bullseye" style="color: #27AE60; margin-right: 6px;"></i><strong>Target:</strong></div>
              <div style="font-size: 18px; font-weight: bold; color: #28a745;">${updatedTargetCount}</div>
            </div>
    
            <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
              <div style="font-size: 16px; color: #2C3E50;"><i class="fas fa-check-circle" style="color: #17A2B8; margin-right: 6px;"></i><strong>Attained:</strong></div>
              <div style="font-size: 18px; font-weight: bold; color: #17a2b8;">${updatedAttainedCount}</div>
            </div>
    
            <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
              <div style="font-size: 16px; color: #2C3E50;"><i class="fas fa-exclamation-circle" style="color: rgb(205, 146, 44); margin-right: 6px;"></i><strong>Remaining:</strong></div>
              <div style="font-size: 18px; font-weight: bold; color: ${remainingTarget <= 0 ? '#28a745' : '#17a2b8'};">${Math.max(0, remainingTarget)}</div>
            </div>
    
            <div style="margin-top: 20px;">
              <strong>Progress:</strong>
              <div style="background-color: #ddd; border-radius: 5px; height: 20px; overflow: hidden; width: 100%;">
                <div style="background-color: #28a745; height: 100%; width: ${barWidth}%; text-align: center; color: white; font-weight: bold;">
                  ${progressPercentage}%
                </div>
              </div>
            </div>
    
            ${remainingTarget <= 0 ? `
              <div style="text-align: center; margin-top: 20px; padding: 10px; background-color: #E8F8E9; border-radius: 8px;">
                <p style="color: #28a745; font-weight: bold; font-size: 18px; margin: 0;">🎉 Great Job! You've met or exceeded your target! 🎉</p>
              </div>
            ` : ''}
          </div>
        `,
        icon: remainingTarget <= 0 ? "success" : "success",
        confirmButtonText: "<i class='fas fa-thumbs-up'></i> OK",
        showCloseButton: true,
        background: "#FDFEFE",
        color: "#2C3E50",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-confirm-button",
        },
        width: "480px",
        padding: "15px",
      });
    }, 1000);
    

    const style = document.createElement('style');
    style.innerHTML = `
      .custom-button {
        width: 150px;
        font-size: 14px;
      }
    `;
    document.head.appendChild(style);
  } catch (error) {
    Swal.fire({
      title: "Error!",
      text: "Failed to fetch target data.",
      icon: "error",
      confirmButtonText: "OK",
    });
    console.error("Error fetching target:", error);
  }
};




const updateAttainedPubTarget = async (targetId, publicationCount) => {
  try {

    const updateUrl = `${process.env.REACT_APP_API_BASE_URL}/api/targets/${targetId}/updateAttainedPubTarget?newAttainedPubTarget=${publicationCount}`;
    
    const response = await fetch(updateUrl, {
      method: "PUT",
    });

    if (!response.ok) {
      throw new Error("Failed to update the target");
    }

    const data = await response.text(); // Expecting a plain text response
    console.log("Successfully updated target:", data);
  } catch (error) {
    console.error("Error updating the target:", error);
  }
};


// Fetch publications whenever the findTarget state or other conditions change


  useEffect(() => {
      const getPublications = async () => {
          try {
              const response = await fetch(
                  `${process.env.REACT_APP_API_BASE_URL}/api/publications/publications?page=${currentPage - 1}&size=${pageSize}`
              );
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              const data = await response.json();
              const allPublications = data._embedded?.publications || [];
              setPublications(allPublications);
              
              // Set the total number of pages from the response
              const totalPages = data.page?.totalPages || 0;
              setTotalPages(totalPages);
          } catch (error) {
              console.error('Error fetching publications:', error);
              setError('Failed to fetch publications.');
          } finally {
              setLoading(false);
          }
      };

      getPublications();
  }, [currentPage]);  
  // Fetch data when the page changes

  const handlePrevPage = () => {
      if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
      }
  };

  const handleNextPage = () => {
      if (currentPage < totalPages) {
          setCurrentPage(currentPage + 1);
      }
  };

  // Handle checkbox state change for individual publications
  const handleCheckboxChange = (pubId) => {
      const newSelectedPublications = new Set(selectedPublications);
      if (newSelectedPublications.has(pubId)) {
          newSelectedPublications.delete(pubId);
      } else {
          newSelectedPublications.add(pubId);
      }
      setSelectedPublications(newSelectedPublications);
  };  

  const handleSelectPublication = (publication) => {
      history.push({
    pathname: `/view/${publication.id}`,
    state: { publication }, // Passing the publication as state
  });

  };

  const handleDeleteSelected = async () => {
      try {
          const deletePromises = Array.from(selectedPublications).map((pubId) => {
              return fetch(`${process.env.REACT_APP_API_BASE_URL}/api/publications/publications/${pubId}`, {
                  method: 'DELETE',
              });
          });
          await Promise.all(deletePromises);
          setSelectedPublications(new Set());

          // Re-fetch the updated publication list after deletion
          const response = await fetch(
              `${process.env.REACT_APP_API_BASE_URL}/api/publications/publications?page=${currentPage - 1}&size=${pageSize}`
          );
          const data = await response.json();
          const updatedPublications = data._embedded ? data._embedded.publications : [];
          setPublications(updatedPublications);
      } catch (error) {
          console.error('Error deleting publications:', error);
          setError('Failed to delete selected publications. Please try again.');
      }
  };
 
  
  // Apply filters (if any)
  const filteredPublications = publications.filter((pub) => {
      const lowerCaseQuery = searchQuery.toLowerCase();

      const matchesQuery =
          (pub.title && pub.title.toLowerCase().includes(lowerCaseQuery)) ||
          (pub.doi && pub.doi.toLowerCase().includes(lowerCaseQuery)) ||
          (pub.publicationDate && pub.publicationDate.toLowerCase().includes(lowerCaseQuery));

      const matchesFilters =
          filters &&
          Object.keys(filters).every((key) => {
              if (!filters[key]) return true;
              return pub[key] && pub[key].toLowerCase().includes(filters[key].toLowerCase());
          });

      return matchesQuery && matchesFilters;
  });

  if (loading) {
      return (
          <div className="text-center">
              <div className="border rounded m-3 p-2">
                  <span className="me-2 spinner-border spinner-border-md mt-1" role="status" aria-hidden="true"></span>
                  <span className="sr-only text-bold mt-5">
                      <strong style={{ fontSize: '34px' }}>Loading...</strong>
                  </span>
              </div>
          </div>
      );
  }

  return (
      <div className="container">
          {/* Filter Container Component */}
          <div className="col-md-12 d-flex align-items-center justify-content-start mt-5 gap-3">
  {/* Search Field */}
  <input
    type="text"
    className="form-control"
    placeholder="Search by Title or DOI"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    style={{ width: '300px' }}
  />

  {/* Checkbox */}
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="findTargetCheckbox"
      checked={findTarget}
      onChange={(e) => setFindTarget(e.target.checked)}
    />
    <label className="form-check-label" htmlFor="findTargetCheckbox">
    Check Target
    </label>
  </div>

  {/* Conditional Fields (Department Dropdown, From Year, To Year) */}
  {findTarget && (
    <>
     <select
            className="form-select"
            value={selectedDepartment}
            onChange={(e) => setSelectedDepartment(e.target.value)}
            style={{ width: "200px" }}
          >
            <option value="">Select Department</option>
            {departments.map((dept) => (
              <option key={dept.deptId} value={dept.deptId}>
                {dept.deptName}
              </option>
            ))}
          </select>
         
  {/* From Year - Academic Year Start */}
  <select
    className="form-control me-2"
    onChange={(e) => {
      const selectedYear = e.target.value;
      setFromYear(selectedYear);
      setToYear(`${parseInt(selectedYear) + 1}`); // Automatically set To Year as the next year
    }}
    value={fromYear || ""}
    style={{ width: '150px' }}
  >
    <option value="">Select Academic Year</option>
    {[...Array(30)].map((_, index) => {
      const year = new Date().getFullYear() - index;
      return (
        <option key={year} value={year}>
          {year}
        </option>
      );
    })}
  </select>

  <span className="me-2">to</span>

  {/* To Year - Automatically Set (Read-Only) */}
  <input
    type="text"
    className="form-control me-2"
    value={toYear || ""}
    disabled
    style={{ width: '150px' }}
  />


       <button
    className="btn btn-primary"
    onClick={() => { fetchPublicationss();  }}  // Call the fetch function on button click
  >
    Find
  </button>
    </>
  )}
</div>

          {error && <div className="alert alert-danger">{error}</div>}

          <div className="row">
              <div className="col-12">
                  {filteredPublications.length === 0 ? (
                      <div className="alert alert-primary">No Record Found</div>
                  ) : ( <div style={{ maxHeight: '450px', overflowY: 'auto' }}>
                      <div className="table-responsive border rounded table-blue">
                          <table className="table table-striped table-bordered rounded table-blue">
                              <thead className="table-secondary">
                                  <tr>
                                      
                                      <th scope="col">ID</th>
                                      <th scope="col">Title</th>
                                      <th scope="col">DOI</th>
                                      <th scope="col">Publication Date</th>
                                      <th scope="col">Action</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  {filteredPublications.map((pub, index) => (
                                      <tr key={index}>
                                          
                                          <th scope="row">{pub.id}</th>
                                          <td>{pub.title}</td>
                                          <td style={{ wordWrap: "break-word", whiteSpace: "normal", maxWidth: "150px" }}>
  {pub.doi}
</td>

                                          <td>{pub.publicationDate}</td>
                                          <td>
                                              <button
                                                  className="btn btn-primary"
                                                  onClick={() => handleSelectPublication(pub)}
                                              >
                                                  View Details
                                              </button>
                                          </td>
                                      </tr>
                                  ))}
                              </tbody>
                          </table>
                      </div>
                      </div>
                  )}
              </div>
          </div>

          <div className="mt-3 d-flex justify-content-between">
              <button
                  className="btn btn-secondary"
                  onClick={handlePrevPage}
                  disabled={currentPage <= 1}
              >
                  Previous
              </button>
              <span>
                  Page {currentPage} of {totalPages}
              </span>
              <button
                  className="btn btn-secondary"
                  onClick={handleNextPage}
                  disabled={currentPage >= totalPages}
              >
                  Next
              </button>
          </div>

          {selectedPublications.size > 0 && (
              <div className="mt-3 text-end">
                  <button className="btn btn-danger" onClick={handleDeleteSelected}>
                      Delete Selected
                  </button>
              </div>
          )}
      </div>
  );
};

export default Publication1;
